<template>
  <ll-modal
    v-model:open="open"
    title="Cron表达式"
    :width="1000"
    :class="bem.b()"
    :keyboard="false"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <CronInner v-bind="attrs" />
  </ll-modal>
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { ref, useAttrs } from 'vue'
import CronInner from './cron-inner.vue'
defineOptions({ name: 'LlCronModal' })

const bem = createNamespace('cron-modal')
const emit = defineEmits(['ok'])
const attrs = useAttrs()
const open = ref(false)

function openModal() {
  open.value = true
}
function handleCancel() {
  open.value = false
}
function handleSubmit() {
  handleCancel()
  emit('ok')
}
defineExpose({ openModal })
</script>
